import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { NotificationService } from './notification.service';
import { Errors } from './error.codes';
import { UtilityService } from '../services/utility.service';
import { CONSTANTS } from '../constants';
import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  header: string = '';
  constructor(private notificationUtil: NotificationService,
    private utilityService: UtilityService,
    private router: Router,
    private errors: Errors
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //this.header = this.utilityService.getObject(CONSTANTS.COOKIE.HEADER);
    let token = sessionStorage.getItem(CONSTANTS.COOKIE.HEADER_TOKEN)
    this.header = (token === null) ? '' : token
    if (this.header != '') {
      //Login without logout - Token present in cookie
      if (request.url.endsWith('auth/login')) {
      //  request.body.password = this.cypherUtil.hardEncrypt(request.body.password, "");
      } else {
        //After login
        request = request.clone({
          headers: new HttpHeaders({
            'Authorization': `Bearer ${this.header}`
          })
        });
      }
    } else {
      //Login & Registration Request Interception
      if (request.body && request.body.password && request.body.password != null && request.body.password.length > 0) {
     //   request.body.password = this.cypherUtil.hardEncrypt(request.body.password, "");
      }
    }

    if (request.body instanceof FormData) {

    } else {
     /* request = request.clone({
        body: { "content": JSON.stringify(request.body) }
      })*/
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          var response = event.body;
          if (response.response_code == "1001" && response.errors.length > 0) {
            if(response.errors[0].code == 'FAQ.0.0.1.3' || response.errors[0].code == 'FAQ.0.0.1.4'
            || response.errors[0].code == 'FAQ.0.0.1.12' || response.errors[0].code == 'FAQ.0.0.1.13'
            || response.errors[0].code == 'FAQ.0.0.1.14'){
              this.utilityService.removeAllCookies();
              sessionStorage.clear();
              //this.ss.disconnect();
              this.router.navigate(['']);
            } else {
              this.notificationUtil.showAlert('error', response.errors[0].data);
            }
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.notificationUtil.showAlert("error", "Internal error occured. Please try again.")
        return throwError(error);
      }));
  }
}
